import React from 'react';

const ROW1_LOGOS = [
  '/assets/images/horizon-suites-color-logo1.webp',
  '/assets/images/mario-enzo-color-logos1.webp',
  '/assets/images/nafees-rentacar-color-logo1.webp',
  '/assets/images/premium-glove-color-logo1.webp',
  '/assets/images/shaykis-fireworks-color-logo1.webp',
  '/assets/images/amore-jewel-color-logo1.webp',
  '/assets/images/thepatchio-color-logo1.webp'
];

const ROW2_LOGOS = [
  '/assets/images/trends-alley-color-logo1.webp',
  '/assets/images/guiltless-color-logo1.webp',
  '/assets/images/shaykis-fireworks-color-logo1.webp',
  '/assets/images/premium-glove-color-logo1.webp',
  '/assets/images/nafees-rentacar-color-logo1.webp',
  '/assets/images/mario-enzo-color-logos1.webp',
  '/assets/images/horizon-suites-color-logo1.webp'
];

// Double the arrays to enable seamless infinite scrolling marquee
const row1Extended = [...ROW1_LOGOS, ...ROW1_LOGOS, ...ROW1_LOGOS];
const row2Extended = [...ROW2_LOGOS, ...ROW2_LOGOS, ...ROW2_LOGOS];

function PartnerLogos() {
  return (
    <section className="partner-logos-section">
      <div className="partner-logos-wrapper">
        
        {/* Top Row: Scrolls Left */}
        <div className="logos-marquee-container marquee-left">
          <div className="marquee-track">
            {row1Extended.map((logo, idx) => (
              <div className="logo-item" key={`row1-${idx}`}>
                <img src={logo} alt="Partner Logo" className="partner-logo-img" />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Row: Scrolls Right */}
        <div className="logos-marquee-container marquee-right">
          <div className="marquee-track">
            {row2Extended.map((logo, idx) => (
              <div className="logo-item" key={`row2-${idx}`}>
                <img src={logo} alt="Partner Logo" className="partner-logo-img" />
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default PartnerLogos;
